module.exports = __webpack_public_path__ + "img/robotIcon-swiper-img2.71d8c7d6.png";